"use strict";

var isValue = require("./is-value");

var map = { function: true, object: true };

module.exports = function (value) {
	return (isValue(value) && map[typeof value]) || false;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/is-object.js
// module id = 716
// module chunks = 0